import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { t } from "../../i18next"
import DamageCaseIcon from "../../images/icons/damage_case-104.png"
import { BackNavigator, LhoHeaderText, PageHeader, PosedAppContent } from "../common"
import { CodeTable, getCodeTableEntries } from "../common/codeTableAccess"
import { startCase } from "../damage-case/redux/actions"

import * as actions from "./redux/actions"
import WithLgDetail from "./WithLgDetail"
import { LhoActions, UnitsDrilldown } from "."

export class LhoHousePage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    drillUp: PropTypes.bool,
    unitTypes: PropTypes.array.isRequired,
    propertyRef: PropTypes.string.isRequired,
    houseRef: PropTypes.string.isRequired,
    house: PropTypes.object,
  }

  render() {
    const { propertyRef, house } = this.props

    return (
      <div className="lho-explorer-lho-house-page">
        <PageHeader>
          <BackNavigator url={propertyRef} />
          <div className="header-text">
            <LhoHeaderText lhoRef={this.lhoRef()} house={house} />
          </div>
        </PageHeader>

        <PosedAppContent
          className="app-content"
          initialPose={this.props.drillUp ? "unmountedUp" : "unmountedDown"}
          pose={"mounted"}
        >
          <WithLgDetail propertyRef={propertyRef}>{this.renderDetail()}</WithLgDetail>
        </PosedAppContent>
      </div>
    )
  }

  renderDetail() {
    const { house, unitTypes } = this.props
    const { startCase } = this.props.actions

    if (house) {
      return [
        <div key="0" className="app-content_middle">
          <LhoActions className="house-actions">
            <button className="lho-action-button" onClick={() => startCase(house.reference)}>
              <img className="icon icon-damage_case" alt={t("damageCase.title")} src={DamageCaseIcon} />
            </button>
          </LhoActions>
        </div>,
        <UnitsDrilldown key="1" className="app-content_right" units={house.units || []} unitTypes={unitTypes} />,
      ]
    } else {
      return <div className="lg-detail-missing-message">{t("lho.noHouseFound", { ref: this.lhoRef() })}</div>
    }
  }

  lhoRef() {
    const { propertyRef, houseRef } = this.props
    return [propertyRef, houseRef].join(".")
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { propertyRef, houseRef } = ownProps.match.params
  const lhoData = state.home && state.home.lhoData

  const unitTypes = getCodeTableEntries(state, CodeTable.unitTypes)
  const properties = lhoData && lhoData.properties
  const property = properties && properties.find(p => p.reference === propertyRef)
  const houses = property && property.houses
  const house = houses && houses.find(h => h.reference === [propertyRef, houseRef].join("."))

  const drillUp = state.router.location.drillUp

  return {
    drillUp,
    unitTypes,
    propertyRef,
    houseRef,
    house,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, startCase }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LhoHousePage)



// WEBPACK FOOTER //
// ./src/features/lho-explorer/LhoHousePage.js